const newBoldLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><path d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12M7.83 13.33l3.74-6.53h4.66l-3.08 3.73h4.02L9.23 18l1.87-4.67z" clip-rule="evenodd"/></svg>',
};

export { newBoldLarge as default };
